import imgBanner from './../assets/banner-seagame33.jpg';
import logoSG from '../assets/logoSG2.png';
import { useState, useEffect } from 'react';
import { hover } from 'framer-motion';
function Header() {
	const [active, setActive] = useState('home');
	const [hovered, setHovered] = useState(null);

	const menus = [
		{ id: 'home', label: 'Trang chủ' },
		{ id: 'live', label: 'Truyền hình trực tiếp' },
		{ id: 'videos', label: 'Video Clip' },
		{ id: 'images', label: 'Hình ảnh' },
	];

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setActive(entry.target.id);
					}
				});
			},
			{ threshold: 0.4 }
		);

		menus.forEach((item) => {
			const el = document.getElementById(item.id);
			if (el) observer.observe(el);
		});

		return () => observer.disconnect();
	}, []);

	const scrollToSection = (id) => {
		setActive(id);
		document.getElementById(id)?.scrollIntoView({
			behavior: 'smooth',
		});
	};

	const activeMenu = hovered || active;

	return (
		<div id='home' className='scroll-mt-[100px]'>
			<div className='hidden fixed top-0 left-0 w-full z-50 lg:flex items-center justify-between px-48 py-3 bg-gray-800 h-[85px]'>
				<div
					className='flex flex-col items-center text-white font-semibold ml-6 cursor-pointer'
					onClick={() => scrollToSection('home')}
				>
					<img src={logoSG} width={45} alt='' />
					<span>SEA GAMES 33</span>
				</div>
				<div className='text-white flex flex-row gap-10 '>
					{menus.map((item) => (
						<button
							key={item.id}
							onClick={() => scrollToSection(item.id)}
							onMouseEnter={() => setHovered(item.id)}
							onMouseLeave={() => setHovered(null)}
							className='relative uppercase font-semibold'
						>
							{item.label}

							{/* Gạch dưới */}
							<span
								className={`
									absolute left-0 -bottom-7 h-[4px] bg-[#2469f6]
									transition-all duration-300
									${activeMenu === item.id ? 'w-full' : 'w-0 group-hover:w-full'}
								`}
							/>
						</button>
					))}
				</div>
			</div>
			<div className='lg:mt-[85px]'>
				<img src={imgBanner} alt='Seagame 33' className='w-full' />
			</div>
		</div>
	);
}

export default Header;
